import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  class: "section",
  id: "repayment-summary"
}
const _hoisted_2 = {
  class: "container",
  id: "summary-items"
}
const _hoisted_3 = { class: "summary-items-header" }
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = { class: "summary-items" }
const _hoisted_6 = { class: "summary-item" }
const _hoisted_7 = { class: "summary-item" }
const _hoisted_8 = {
  key: 0,
  class: "sc-tooltip-container"
}
const _hoisted_9 = { class: "tooltip-text bottom no-arrow-indicator" }
const _hoisted_10 = { class: "summary-item" }
const _hoisted_11 = { class: "summary-item" }

import { computed, ref, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import Icon from "@/components/shared/Icon.vue";
import type { RatePlanVM } from "@/models/loanConfiguration";

const key = "repaymentSummary";


export default /*@__PURE__*/_defineComponent({
  __name: 'RepaymentSummary',
  props: {
    repaymentSummary: {},
    isMobile: { type: Boolean, default: false },
    ratePlan: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const route = useRoute();
const router = useRouter();
const isOpen = ref<boolean>(true);

const hasRepaymentTermTooltip = computed<boolean>(() => {
  return (
    (props.ratePlan &&
      props.ratePlan?.repaymentTermDetails &&
      props.ratePlan?.repaymentTermDetails?.tooltipText !== null &&
      props.ratePlan?.repaymentTermDetails?.tooltipText !== undefined) === true
  );
});

function toggleSection() {
  isOpen.value = !isOpen.value;

  router.push({
    query: {
      ...route.query, // Preserve existing queries
      repaymentSummary: isOpen.value ? "expanded" : "collapsed", // Add/update the 'step' query
    },
  });
}

onMounted(() => {
  // get the url parameter
  if (Object.keys(route.query).includes(key)) {
    // check if value is valid
    const validKeys = ["expanded", "collapsed"];

    if (validKeys.includes(route.query[key]?.toString() || "")) {
      route.query[key]?.toString() === "expanded" ? (isOpen.value = true) : (isOpen.value = false);
    }
  }
});

__expose({
  isOpen,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "title" }, [
          _createElementVNode("h5", null, "Repayment Summary")
        ], -1)),
        _createElementVNode("a", {
          href: "",
          class: "toggle-btn",
          "aria-label": isOpen.value ? 'collapse' : 'expand',
          onClick: _withModifiers(toggleSection, ["prevent"])
        }, [
          _createVNode(Icon, {
            class: "toggle-icon",
            icon: isOpen.value ? 'chevron-up' : 'chevron-down'
          }, null, 8, ["icon"])
        ], 8, _hoisted_4)
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _cache[1] || (_cache[1] = _createElementVNode("p", null, "Rate Type", -1)),
          _createElementVNode("p", null, _toDisplayString(__props.repaymentSummary?.rateType || "—"), 1)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _cache[2] || (_cache[2] = _createElementVNode("p", null, "Repayment Term", -1)),
          _createElementVNode("p", null, [
            _createTextVNode(_toDisplayString(__props.repaymentSummary?.repaymentTerm || "—") + "  ", 1),
            (hasRepaymentTermTooltip.value)
              ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                  _createVNode(Icon, {
                    icon: "info",
                    class: "tooltip-toggle"
                  }),
                  _createElementVNode("span", _hoisted_9, _toDisplayString(__props.ratePlan?.repaymentTermDetails?.tooltipText), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[3] || (_cache[3] = _createElementVNode("p", null, "Repayment Type", -1)),
          _createElementVNode("p", null, _toDisplayString(__props.repaymentSummary?.repaymentType || "—"), 1)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _cache[4] || (_cache[4] = _createElementVNode("p", null, "Interest Rate", -1)),
          _createElementVNode("p", null, _toDisplayString(__props.repaymentSummary?.interestRate || "—"), 1)
        ])
      ], 512), [
        [_vShow, isOpen.value || !__props.isMobile]
      ])
    ]),
    _cache[5] || (_cache[5] = _createElementVNode("small", { class: "container" }, "Selections are not final until process is completed.", -1))
  ]))
}
}

})